<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardBody>

                <ProductReportQty :product_master_name="name" :models="unit_model_items"/>

          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';

import ProductReportQty from "../products/ProductReportQty";

export default {
  name: 'Login',
  components: {

    ProductReportQty
  },
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      name: '',
      selected_product_name: '',
      unit_model_items: [],

    }
  }, mounted() {

  }, watch: {

  },
  methods: {

  }
}

</script>
